import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import {
  GenericExportDialogComponent,
  GenericExportDialogConfig,
} from '@tv3/shared/dialogs/generic-export-dialog/generic-export-dialog.component'
import * as moment from 'moment'
import { select, Store } from '@ngrx/store'
import { Rental, selectRentalEntities } from '@tokeet-frontend/tv3-platform'
import { ChannelReviewItem, getChannelMaxRating } from '@tokeet-frontend/reviews'
import { DatePipe } from '@angular/common'

@Injectable()
export class ExportReviewDialogService {
  rentalsById: Record<string, Rental> = {}

  constructor(private dialog: MatDialog, private store: Store<any>) {
    this.store.pipe(select(selectRentalEntities)).subscribe((d) => (this.rentalsById = d))
  }

  private getConfig(data: ChannelReviewItem[]): GenericExportDialogConfig {
    const dateFormatter = new DatePipe('en-US')
    return {
      title: $localize`Download Reviews to CSV`,
      description: $localize`You are about to download all tasks within your current filter.`,
      columns: [
        { name: $localize`Review of`, field: (t: ChannelReviewItem) => this.rentalsById[t.rentalId]?.name },
        {
          name: $localize`Date`,
          field: (t: ChannelReviewItem) => dateFormatter.transform(t.submittedAt, 'dd - MMM - yyyy'),
        },
        {
          name: $localize`Rating`,
          field: (t: ChannelReviewItem) => `${t.channelOverallRating}/${getChannelMaxRating(t.source)}`,
        },
        { name: $localize`Channels`, field: 'source' },
        { name: $localize`Review`, field: 'text' },
        { name: $localize`Publish`, field: (t) => (t.published ? 'Published' : '') },
      ],
      exportData: data,
      filename: $localize`Reviews` + ` - ${moment().format('MM_DD_YYYY')}`,
      columnCustomizable: false,
    }
  }

  open(items: ChannelReviewItem[]) {
    const defaultConfig: MatDialogConfig = {
      width: '650px',
      panelClass: ['variable-modal'],
      data: {
        config: this.getConfig(items),
      },
    }

    return this.dialog.open(GenericExportDialogComponent, defaultConfig)
  }
}
